export default "__VITE_ASSET__Wh32Krl___"